exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-label-body{\r\n/*\tborder: 1px solid rgb(193, 193, 193);*/\r\n\tpadding: 23px 10px 10px 10px;\r\n\tword-break: break-all;\r\n\tline-height: normal;\r\n\tfont-size: 14px;\n}\n.custom-label-header{\r\n/*\tborder: 1px solid #c1c1c1;*/\r\n\tposition: relative;\r\n\twidth: 80%;\r\n\tpadding: 0px 5px 0px 5px;\r\n\tmargin: 0px 0px -18px 5px;\r\n\tbackground: #f7f6f6;\r\n\tword-break: break-all;\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\n}\r\n", ""]);

// exports
